import { ResizeObserver } from 'resize-observer';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import * as profileFallback from 'assets/img/UserNone.svg';
import * as DefaultAvatar from 'assets/img/icons/avatar-default.png';
import './UserDetail.scss';
import { AttendanceConstants } from 'modules/application/detail/attendance//AttendanceConstants';
import { UserFeatures } from 'modules/application/detail/users/UserFeatures';
import { APP_DESCRIPTION } from '../UsersSegmentEvents';
import { AttendanceFeatures } from 'modules/application/detail/attendance/AttendanceFeatures';
import { asyncFetchMediaWithAuth } from 'modules/shared/helpers/Media';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { DashboardFeatures } from '../../attendance/dashboard/DashboardFeatures';
import { CallsFeatures } from 'modules/calls/CallsFeatures';
import { GeneralSettingsConstants } from '../../attendance/generalsettings/GeneralSettingsConstants';
import { TicketLinkModalController } from 'modules/application/detail/users/detail/ticketLinkModal/TicketLinkModalController';
import TicketLinkModalView from 'modules/application/detail/users/detail/ticketLinkModal/TicketLinkModalView.html';
import { ConfirmationModal } from 'modules/ui';
const TESTER_GROUP_NAME = 'Testers';
export class UserDetailController {
    static $inject = ['application', 'TeamService', 'HistoryService', 'LoadingService', 'UsersSegmentService', 'TenantService', '$timeout', '$stateParams', '$translate', 'ngToast', 'UsersService', '$scope', 'BlipToastService', 'MessagingHubService', '$state', 'ApplicationService2', 'AuthenticationService', 'CallsService', 'TranscriptionMfeService', 'DeskConfigurationService', 'MESSAGINGHUBDOMAIN', 'ModalService', 'TicketLinkService'];
    constructor(application, TeamService, HistoryService, LoadingService, UsersSegmentService, TenantService, $timeout, $stateParams, $translate, ngToast, UsersService, $scope, BlipToastService, MessagingHubService, $state, ApplicationService2, AuthenticationService, CallsService, TranscriptionMfeService, DeskConfigurationService, MESSAGINGHUBDOMAIN, ModalService, TicketLinkService) {
        'ngInject';
        this.application = application;
        this.TeamService = TeamService;
        this.HistoryService = HistoryService;
        this.LoadingService = LoadingService;
        this.UsersSegmentService = UsersSegmentService;
        this.TenantService = TenantService;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.UsersService = UsersService;
        this.$scope = $scope;
        this.BlipToastService = BlipToastService;
        this.MessagingHubService = MessagingHubService;
        this.$state = $state;
        this.ApplicationService2 = ApplicationService2;
        this.AuthenticationService = AuthenticationService;
        this.CallsService = CallsService;
        this.TranscriptionMfeService = TranscriptionMfeService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.ModalService = ModalService;
        this.TicketLinkService = TicketLinkService;
        this.tickets = [];
        this.threadData = [];
        this.threadDataReplied = {};
        this.threadDataView = [];
        this.operators = [];
        this.genderOptions = [];
        this.maxMessagesOnThreadView = 200;
        this.isEditing = false;
        this.canLoadTickets = true;
        this.resizeObserver = null;
        this.showLoadMoreRecentButton = false;
        this.downloadedTicketHistoryList = [];
        this.isHidingTestUserCheckbox = false;
        this.isContactTaxDocumentEnabled = false;
        this.isGetMessagingHubCommandWithDelegation = false;
        this.isDisableGetRepliedMessageById = false;
        this.transcriptionData = {};
        this.isAudioTranscriptionCopilotEnabled = false;
        this.isCallRecordingTranscriptionEnabled = false;
        this.isCareCopilotEnabled = false;
        this.isTenantBotBlipCopilotEnabled = false;
        this.isTicketLinkEnabled = false;
        this.changeCustomerDataValue = (event) => {
            const fieldBeingEditted = event.target.getAttribute('name');
            const inputValue = event.detail.value;
            this.editedCustomerData[fieldBeingEditted] = inputValue;
        };
        this.changeGenderOption = (event) => {
            const genderValue = event.detail.value;
            this.editedCustomerData.gender = genderValue;
        };
        this.convertDateTimeByOffset = (datetime, offSet) => {
            if (!(datetime instanceof Date)) {
                datetime = new Date(datetime);
            }
            if (this.offset !== undefined) {
                let timezoneOffset = datetime.getTimezoneOffset() * 60000;
                timezoneOffset -= offSet * 60 * 60000;
                return new Date(datetime.getTime() + timezoneOffset);
            }
            return datetime;
        };
        this.$scope.$on('$destroy', this.$onDestroy.bind(this));
    }
    async $onInit() {
        await this.checkFeatures();
        this.defaultAvatar = DefaultAvatar;
        this.canLoadMore = true;
        this.canLoadTickets = true;
        this.isLoadingTickets = false;
        this.take = 20;
        this.skipTickets = 0;
        this.threadData = [];
        this.UsersSegmentService.setApplication(this.application);
        this.trackUserOpened();
        this.translations = await this.loadTranslations();
        this.genderOptions = [
            {
                value: 'male',
                label: this.$translate.instant('builder-tabs-actions.mergeContact.male'),
            },
            {
                value: 'female',
                label: this.$translate.instant('builder-tabs-actions.mergeContact.female'),
            },
        ];
        if (this.$stateParams.id) {
            const customerIdFromParams = this.$stateParams.id;
            const decodedCustomerIdName = customerIdFromParams.slice(0, customerIdFromParams.lastIndexOf('@'));
            const customerIdName = this.isNecessaryEncode(decodedCustomerIdName)
                ? encodeURIComponent(decodedCustomerIdName)
                : decodedCustomerIdName;
            const customerDomain = customerIdFromParams.substring(customerIdFromParams.lastIndexOf('@'));
            this.customerId = `${customerIdName}${customerDomain}`; //Concatenating userId (encoded) with user domain (not encoded)
            this.fetchUser();
        }
        if (this.$stateParams.ticketId) {
            this.currentTicketId = this.$stateParams.ticketId;
            await this.getLinkedTicket(this.currentTicketId);
        }
        if (this.$stateParams.offset) {
            this.offset = this.$stateParams.offset;
        }
        const contactId = this.customerId;
        const extra = {
            bot_id: this.application.shortName,
            tenant_id: this.application.tenantId,
            cluster: this.application.cluster,
        };
        this.transcriptionData = {
            audioEnabled: this.isAudioTranscriptionEnabled(),
            callRecordingEnabled: this.isCallRecordingTranscriptionEnabled,
            onAsyncTranscribe: url => {
                const ticket = this.tickets.find(x => x.id === this.currentTicketId);
                const extraPayload = { ...extra, source: 'copilot', ticket_id: this.currentTicketId, agent_identity: ticket?.agentIdentity, team: ticket?.team };
                this.TranscriptionMfeService.show({ url, extraPayload, contactId });
                return '';
            },
            onOpenMfeModal: data => {
                const ticket = this.tickets.find(x => x.id === this.currentTicketId);
                const extraPayload = { ...extra, source: data.source ?? 'calls', ticket_id: this.currentTicketId, agent_identity: ticket?.agentIdentity, team: ticket?.team };
                this.TranscriptionMfeService.show({ ...data, extraPayload, contactId });
            },
        };
        const container = document.getElementById('blip-chat-container');
        if (container) {
            container.style.display = 'none';
        }
        this.profileFallback = profileFallback;
        this.sideBarElement = document.getElementById('user-detail-sidebar');
        this.mainNavElement = document.getElementById('main-navbar');
        this.contentElement = document.getElementsByClassName('main-section')[0];
        setTimeout(() => {
            if (this.mainNavElement) {
                this.resizeObserver = new ResizeObserver(this.onResizeNavbar.bind(this));
                this.resizeObserver.observe(this.mainNavElement);
            }
        });
        // store bound reference to allow removal later
        this.boundOnScrollOrResizePage = this.onScrollOrResizePage.bind(this);
        window.addEventListener('scroll', this.boundOnScrollOrResizePage);
        window.addEventListener('resize', this.boundOnScrollOrResizePage);
        this.threadWrapper = document.getElementById('thread-wrapper');
        this.scrollThread = this.debounce(this.scrollThreadMessage.bind(this));
        this.threadWrapper.addEventListener('scroll', this.scrollThread);
    }
    $onDestroy() {
        if (this.boundOnScrollOrResizePage) {
            window.removeEventListener('scroll', this.boundOnScrollOrResizePage);
            window.removeEventListener('resize', this.boundOnScrollOrResizePage);
        }
        if (this.threadWrapper && this.scrollThread) {
            this.threadWrapper.removeEventListener('scroll', this.scrollThread);
        }
        if (this.resizeObserver && this.mainNavElement) {
            try {
                this.resizeObserver.unobserve(this.mainNavElement);
            }
            catch (e) {
                // ignore errors during destroy
            }
            this.resizeObserver = null;
        }
    }
    async checkFeatures() {
        const [isOrganizationEnabled, isDownloadTicketHistoryEnabled, isHidingTestUserCheckbox, isContactTaxDocumentEnabled, isGetMessagingHubCommandWithDelegation, isDisableGetRepliedMessageById, isAudioTranscriptionCopilotEnabled, isCallRecordingTranscriptionEnabled, isCareCopilotEnabled, isTenantBotBlipCopilotEnabled, isTicketLinkEnabled,] = await Promise.all([
            this.TenantService.isOrganizationEnabled(),
            UserFeatures.downloadTicketHistoryEnabled(),
            UserFeatures.isHidingTestUserCheckbox(),
            UserFeatures.isContactTaxDocumentEnabled(),
            MessagingHubFeatures.GetMessagingHubCommandWithDelegation(),
            UserFeatures.isDisableGetRepliedMessageById(),
            DashboardFeatures.isAudioTranscriptionCopilotEnabled(),
            CallsFeatures.isCallRecordingTranscriptionEnabled(),
            this.DeskConfigurationService.getDeskConfiguration(GeneralSettingsConstants.CARE_COPILOT_ENABLED, false),
            this.DeskConfigurationService.getDeskConfiguration(GeneralSettingsConstants.TENANT_BOT_BLIP_COPILOT_ENABLED, false),
            UserFeatures.isTicketLinkEnabled(),
        ]);
        this.isOrganizationEnabled = isOrganizationEnabled;
        this.isDownloadTicketHistoryEnabled = isDownloadTicketHistoryEnabled;
        this.isHidingTestUserCheckbox = isHidingTestUserCheckbox;
        this.isContactTaxDocumentEnabled = isContactTaxDocumentEnabled;
        this.isGetMessagingHubCommandWithDelegation = isGetMessagingHubCommandWithDelegation;
        this.isDisableGetRepliedMessageById = isDisableGetRepliedMessageById;
        this.isAudioTranscriptionCopilotEnabled = isAudioTranscriptionCopilotEnabled;
        this.isCallRecordingTranscriptionEnabled = isCallRecordingTranscriptionEnabled;
        this.isCareCopilotEnabled = isCareCopilotEnabled;
        this.isTenantBotBlipCopilotEnabled = isTenantBotBlipCopilotEnabled;
        this.isTicketLinkEnabled = isTicketLinkEnabled;
    }
    isAudioTranscriptionEnabled() {
        return this.isAudioTranscriptionCopilotEnabled
            && this.isCareCopilotEnabled
            && this.isTenantBotBlipCopilotEnabled;
    }
    scrollThreadMessage(event) {
        event.stopPropagation();
        const scrollIsOnBottom = ((event.srcElement.scrollHeight - event.target.clientHeight - event.srcElement.scrollTop) <= 1);
        this.$timeout(() => {
            this.showLoadMoreRecentButton = !scrollIsOnBottom;
        });
    }
    isNecessaryEncode(customerIdentity) {
        const firstChar = customerIdentity.slice(0, 1).includes('+');
        /* If customer ID starts with '+' it is not encoded in Database.
            So, is not needed to encode it before perform search operation.
            */
        if (firstChar) {
            return false;
        }
        // If customer ID with '/' it is not encoded in Database.
        if (customerIdentity.includes('/')) {
            return false;
        }
        return true;
    }
    setSidebarPosition({ top, height }) {
        this.sideBarElement.style.top = top === '0px' ? '136px' : top;
        this.sideBarElement.style.height = height;
    }
    onResizeNavbar(entries, observer) {
        if (this.sideBarElement) {
            const windowHeight = window.innerHeight;
            const contentTop = this.contentElement.getBoundingClientRect().top;
            const headerSizes = entries[0].contentRect;
            this.setSidebarPosition({
                top: `${headerSizes.height}px`,
                height: contentTop <= 0
                    ? '100%'
                    : windowHeight - this.contentElement.offsetTop + 'px',
            });
        }
    }
    onScrollOrResizePage() {
        if (this.isOrganizationEnabled) {
            return;
        }
        const windowHeight = window.innerHeight;
        const contentTop = this.contentElement.getBoundingClientRect().top;
        const headerBounding = this.mainNavElement.getBoundingClientRect();
        const headerDown = headerBounding.height - headerBounding.bottom;
        this.setSidebarPosition({
            top: contentTop >= 0 ? contentTop + 'px' : '0',
            height: contentTop <= 0
                ? '100%'
                : windowHeight -
                    this.contentElement.offsetTop +
                    headerDown +
                    'px',
        });
    }
    async fetchUser() {
        this.isLoadingTickets = true;
        if (this.customerId.endsWith('@tunnel.msging.net')) {
            try {
                const data = await this.HistoryService.getTunnelAccount(this.customerId);
                this.tunnelAlternativeId = data.alternativeAccount;
                this.ownerId = data.extras
                    ? data.extras['tunnel.owner']
                    : undefined;
            }
            catch (err) {
                console.error(err);
            }
        }
        this.getTickets();
        const ticketId = this.$stateParams.ticketId;
        await this.query(ticketId);
        this.messageReference = ticketId;
        this.updateThreadDataView();
        this.isLoadingTickets = false;
    }
    debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, wait);
        };
    }
    startEditing() {
        this.editedCustomerData = { ...this.customerData };
        this.editedCustomerData.test =
            this.customerData.group === TESTER_GROUP_NAME;
        this.editedCustomerData.extras = this.editedCustomerData.extras || {};
        this.isEditing = true;
    }
    async refresh() {
        this.trackUserRefreshed();
        try {
            this.isLoadingTickets = true;
            this.skipTickets = 0;
            await this.getTickets();
            await this.query(this.$stateParams.ticketId);
            this.updateThreadDataView();
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.canLoadTickets = true;
            this.isLoadingTickets = false;
        }
    }
    async finishEditing(status) {
        if (status === 'finished') {
            try {
                // Check differences between customerData and editedCustomerData
                // before attributes processing
                const changedFields = this.editingChanges();
                this.LoadingService.startLoading();
                const { test, ...rest } = this.editedCustomerData;
                const wasTester = rest.group === TESTER_GROUP_NAME;
                this.customerData = { ...rest };
                this.customerData.group = test ? TESTER_GROUP_NAME : '';
                await this.UsersService.setUser(this.customerData);
                this.trackUserInfoEdited(changedFields);
                this.trackUserTestToggle(test, wasTester);
                const savedMsg = await this.$translate('utils.misc.savedMsg');
                this.ngToast.success(savedMsg);
                this.isEditing = false;
                this.getCustomerData();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.LoadingService.stopLoading();
            }
        }
        else {
            this.isEditing = false;
            this.editedCustomerData = { ...this.customerData };
        }
    }
    updateThreadDataView() {
        if (!this.messageReference) {
            this.threadDataView = this.threadData;
            return;
        }
        const index = this.threadData.map((element) => {
            return element.document.id;
        }).lastIndexOf(this.messageReference);
        const maxDistanceFromReference = this.maxMessagesOnThreadView / 2;
        const firstPosition = (index > maxDistanceFromReference) ? index - maxDistanceFromReference : 0;
        const lastPosition = (index + maxDistanceFromReference > this.threadData.length) ? this.threadData.length : index + maxDistanceFromReference;
        this.threadDataView = this.threadData.slice(firstPosition, lastPosition);
        this.$timeout(() => {
            document
                .getElementById(this.messageReference)?.scrollIntoView();
        });
    }
    async goToMostRecentMessage() {
        if (this.threadData && this.threadData.length > 0) {
            this.isLoadingThreadSpinner = true;
            this.messageReference = this.threadData.slice(-1)[0].document.id;
            this.$timeout(() => {
                this.isLoadingThreadSpinner = false;
                this.updateThreadDataView();
            }, 700);
        }
    }
    async loadMore({ wrapper }, recent = false) {
        this.isLoadingThreadSpinner = true;
        if (this.threadData && this.threadData.length > 0) {
            if (recent) {
                this.messageReference = this.threadDataView.slice(-1)[0].document.id;
                this.isLoadingThreadSpinner = this.messageReference !== this.threadData.slice(-1)[0].document.id;
            }
            else {
                this.messageReference = this.threadDataView[0].document.id;
                await this.loadMoreMessages({ wrapper });
                this.isLoadingThreadSpinner = this.messageReference !== this.threadData[0].document.id;
            }
        }
        this.updateThreadDataView();
        this.$timeout(() => {
            this.isLoadingThreadSpinner = false;
        }, 1000);
    }
    async loadMoreMessages({ wrapper }) {
        if (!this.isLoadingThread) {
            try {
                this.isLoadingThread = true;
                const msgs = await this.getThreads();
                if (msgs) {
                    this.threadData.unshift(...msgs.reverse());
                    this.threadData = this.removeDuplicatedMessages(this.threadData);
                }
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.isLoadingThread = false;
            }
        }
    }
    removeDuplicatedMessages(messagesThread) {
        const existentIds = [];
        return messagesThread.filter(message => {
            if (message?.document?.id &&
                !existentIds.includes(message.document.id)) {
                existentIds.push(message.document.id);
                return true;
            }
            else {
                return false;
            }
        });
    }
    getFilter(data) {
        return `(CustomerIdentity eq '${data.identity}')`;
    }
    async goToTicket(ticket, $event) {
        $event.stopPropagation();
        if (ticket) {
            this.isLoadingThreadSpinner = true;
            this.openTicket = ticket;
            await this.query(ticket.id);
            const ticketMessage = this.threadData.find(x => x.ticket == ticket.id);
            this.trackTicketHistoryThreadViewed();
            if (!ticketMessage) {
                const ticketNotFoundMsg = await this.$translate('utils.errorMsg.182');
                this.BlipToastService.show('danger', { msg: ticketNotFoundMsg });
                this.UsersSegmentService.trackUserTicketHistoryNotFoundOnThreadMessages();
            }
            else {
                this.messageReference = ticketMessage.document.id;
                this.updateThreadDataView();
            }
            this.$timeout(() => {
                this.isLoadingThreadSpinner = false;
            }, 1500);
        }
    }
    async setCurrentTicketId(ticketId) {
        if (this.currentTicketId != ticketId) {
            this.trackTicketHistoryDetailsExpanded();
            await this.getLinkedTicket(ticketId);
        }
        this.currentTicketId =
            ticketId === this.currentTicketId ? '' : ticketId;
    }
    async getLinkedTicket(ticketId) {
        if (!this.isTicketLinkEnabled)
            return;
        try {
            this.isLoadingLinkedTicket = true;
            const data = await this.TicketLinkService.get(ticketId);
            if (data?.id) {
                this.linkedTicket = data;
            }
            else {
                this.linkedTicket = null;
            }
        }
        catch (_) {
            this.linkedTicket = null;
        }
        finally {
            this.isLoadingLinkedTicket = false;
        }
    }
    downloadLoading($event) {
        $event.stopPropagation();
    }
    async downloadTicket(ticket, $event) {
        try {
            ticket.isDownloading = true;
            $event.stopPropagation();
            const url = await this.MessagingHubService.sendCommand({
                id: uuid(),
                method: 'GET',
                to: 'postmaster@desk.msging.net',
                uri: `/ticket/${ticket.id}/history-file`,
                metadata: {
                    'server.shouldStore': true,
                },
            });
            if (!url) {
                return;
            }
            const response = await fetch(url);
            const blob = await response.blob();
            const anchorElement = document.createElement('a');
            anchorElement.href = window.URL.createObjectURL(blob);
            anchorElement.download = `Ticket #${ticket.sequentialId}.pdf`;
            document.body.appendChild(anchorElement);
            anchorElement.click();
            anchorElement.remove();
            this.UsersSegmentService.trackUserTicketHistoryExported({
                success: true,
            });
        }
        catch (error) {
            const msg = await this.$translate('modules.application.detail.attendance.history.errorDownloadingTicketHistory');
            this.BlipToastService.show('danger', { msg });
            this.UsersSegmentService.trackUserTicketHistoryExported({
                success: false,
            });
        }
        finally {
            ticket.isDownloading = false;
        }
    }
    toggleTicketsDetails(ticket) {
        const list = document.querySelector('.tickets-wrapper');
        const details = document.querySelector('.tickets-detail');
        if (ticket) {
            this.openTicket = ticket;
            list.style.display = 'none';
            details.style.display = 'flex';
        }
        else {
            list.style.display = 'flex';
            details.style.display = 'none';
        }
    }
    async query(ticketId) {
        try {
            this.isLoadingThread = true;
            if (ticketId) {
                const foundTicket = this.threadData.find(x => x.ticket == ticketId);
                let getMoreThreads = !foundTicket;
                let timeoutError = false;
                this.$timeout(() => {
                    if (getMoreThreads) {
                        getMoreThreads = false;
                        timeoutError = true;
                    }
                }, 60000);
                while (getMoreThreads) {
                    const items = await this.getThreads();
                    if (items) {
                        this.threadData.unshift(...items.reverse());
                    }
                    else {
                        getMoreThreads = false;
                        break;
                    }
                    if (items.find(x => x.ticket == ticketId)) {
                        getMoreThreads = false;
                    }
                }
                if (timeoutError) {
                    throw new Error('Timed out trying find ticket on threads messages');
                }
            }
            else {
                const msgs = await this.getThreads();
                if (!msgs) {
                    return;
                }
                this.threadData.unshift(...msgs.reverse());
                if (this.threadData.length === msgs.length) {
                    this.$timeout(() => {
                        const threadsElement = document.getElementById('thread-wrapper');
                        threadsElement.scrollTop = threadsElement.scrollHeight;
                    });
                }
            }
        }
        catch (err) {
            console.error(err);
            const errordMsg = await this.$translate('utils.errorMsg.3');
            this.ngToast.warning(errordMsg);
        }
        finally {
            this.isLoadingThread = false;
        }
    }
    async getThreads() {
        if (!this.canLoadMore) {
            return;
        }
        if (this.threadData.length > 0) {
            this.skip = this.threadData[0].document.id;
            this.skipDate = this.threadData[0].document.date;
        }
        const getFromOriginator = this.ownerId && this.isGetMessagingHubCommandWithDelegation;
        const identity = getFromOriginator ? this.customerId : this.tunnelAlternativeId || this.customerId;
        const ownerIdentity = getFromOriginator ? undefined : this.ownerId;
        const { items } = await this.HistoryService.getThreads(identity, this.skip, this.skipDate, this.take, ownerIdentity, getFromOriginator);
        if (items.length == 0) {
            this.canLoadMore = false;
            return;
        }
        const authorization = this.isGetMessagingHubCommandWithDelegation
            ? `${this.AuthenticationService.auth.tokenType} ${this.AuthenticationService.auth.token}`
            : this.ApplicationService2.getAuthHeaderValue(this.application);
        const asyncFetchMediaFunction = asyncFetchMediaWithAuth(this.customerId, authorization);
        const isGetTicketHistoryMergedEnabled = await UserFeatures.isShowingActiveMessageTemplateContent();
        const messages = items.map(item => {
            const convertedDateTime = this.convertDateTimeByOffset(item.date, this.offset);
            if (isGetTicketHistoryMergedEnabled) {
                const contentType = item?.content?.type;
                if (contentType) {
                    item.content.type = (contentType === 'template' ? 'template-content' : contentType);
                }
            }
            const message = {
                document: {
                    id: item.id,
                    date: item.date,
                    type: item.type,
                    content: item.content,
                    direction: item.direction,
                    metadata: item.metadata,
                },
                editable: false,
                deletable: false,
                readonly: true,
                translations: this.translations,
                position: item.direction === 'sent' ? 'left' : 'right',
                date: moment(convertedDateTime).format('L - HH:mm'),
                photo: item.direction === 'sent'
                    ? this.application.imageUri || this.defaultAvatar
                    : false,
                ticket: item.type === 'application/vnd.iris.ticket+json'
                    ? item.content.id
                    : '',
                asyncFetchMedia: asyncFetchMediaFunction,
                onAsyncFetchSession: undefined,
                transcription: this.transcriptionData,
            };
            if (item.type === this.CallsService.CALLS_MEDIA_MESSAGE_TYPE) {
                message.onAsyncFetchSession = this.CallsService.onAsyncFetchSession(`${this.application.shortName}@${this.MESSAGINGHUBDOMAIN}`);
            }
            return message;
        });
        if (!this.isDisableGetRepliedMessageById) {
            await this.fillRepliedMessages(messages, identity, ownerIdentity, getFromOriginator);
        }
        return messages;
    }
    async fillRepliedMessages(items, identity, ownerIdentity, getFromOriginator) {
        const replies = items.filter(x => x.document.type === 'application/vnd.lime.reply+json');
        replies.forEach(async (reply) => {
            const repliedMessageId = reply.document.content.inReplyTo.id;
            const repliedMessage = this.threadDataReplied[repliedMessageId];
            if (!repliedMessage) {
                const response = await this.HistoryService.getThreadMessage(ownerIdentity, identity, repliedMessageId, getFromOriginator);
                if (response) {
                    this.threadDataReplied[repliedMessageId] = this.formatRepliedMessageContent(response);
                }
                else {
                    this.threadDataReplied[repliedMessageId] = {
                        id: repliedMessageId,
                        failedToLoad: true,
                    };
                }
            }
            reply.document.content.inReplyTo = this.threadDataReplied[repliedMessageId];
        });
    }
    formatRepliedMessageContent(repliedMessageDocument) {
        let type = repliedMessageDocument.type;
        let content = repliedMessageDocument.content;
        if (type === 'application/vnd.lime.reply+json') {
            type = repliedMessageDocument.content.replied.type;
            content = repliedMessageDocument.content.replied.value;
        }
        return {
            id: repliedMessageDocument.id,
            value: content,
            type: type,
            direction: repliedMessageDocument.direction,
        };
    }
    async loadTranslations() {
        return {
            messageTemplate: await this.$translate('utils.misc.messageTemplate'),
            audioTranscription: {
                action: await this.$translate('utils.misc.audioTranscription.action'),
                loading: await this.$translate('utils.misc.audioTranscription.loading'),
                fullTranscription: await this.$translate('utils.misc.audioTranscription.fullTranscription'),
                title: await this.$translate('utils.misc.audioTranscription.title'),
                readMore: await this.$translate('utils.misc.audioTranscription.readMore'),
                readLess: await this.$translate('utils.misc.audioTranscription.readLess'),
            },
            userWaitingAttendance: await this.$translate('utils.misc.userWaitingAttendance'),
            replyText: await this.$translate('utils.misc.replyText'),
            callsPermissionRequestBodyTitle: await this.$translate('utils.misc.calls.callsPermissionRequestBodyTitle'),
            callsPermissionRequestBodyText: await this.$translate('utils.misc.calls.callsPermissionRequestBodyText'),
            callsPermissionRequestLeftActionLabel: await this.$translate('utils.misc.calls.callsPermissionRequestLeftActionLabel'),
            callsPermissionRequestRightActionLabel: await this.$translate('utils.misc.calls.callsPermissionRequestRightActionLabel'),
            callsPermissionReplyAcceptText: await this.$translate('utils.misc.calls.callsPermissionReplyAcceptText'),
            callsPermissionReplyRejectText: await this.$translate('utils.misc.calls.callsPermissionReplyRejectText'),
        };
    }
    goToPrevious() {
        const previousStateName = this.$scope.$state.from.name;
        if (previousStateName) {
            this.$state.go(previousStateName, {}, { reload: previousStateName });
        }
    }
    async getCustomerData() {
        try {
            const data = (await this.UsersService.getUser(this.application, this.customerId));
            this.customerData = data;
            this.customerData.displayName = this.customerData.name
                ? this.customerData.name
                : decodeURIComponent(this.customerData.identity.split('@')[0]);
            this.customerData.displayGender = this.customerData.gender
                ? await this.$translate(`utils.misc.${this.customerData.gender}`)
                : undefined;
            this.setCustomerExtras();
        }
        catch (e) {
            this.customerData = {
                displayName: '',
                displayGender: '',
                identity: this.customerId,
            };
        }
    }
    setCustomerExtras() {
        const extras = this.customerData.extras || undefined;
        if (!extras) {
            return;
        }
        this.customerExtras = Object.keys(extras).reduce((arr, key) => [{ key, value: extras[key] }, ...arr], []);
    }
    async loadMoreTickets() {
        if (!this.isLoadingTickets && this.canLoadTickets) {
            this.isLoadingTickets = true;
            this.skipTickets += this.take;
            await this.getTickets();
            this.isLoadingTickets = false;
        }
    }
    async getTickets() {
        await this.getCustomerData();
        const isGetTicketHistoryMergedEnabled = await AttendanceFeatures.isGetTicketHistoryMergedEnabled();
        let items;
        if (isGetTicketHistoryMergedEnabled) {
            ({ items } = await this.HistoryService.getByCustomerMerged(this.customerId, this.skipTickets, this.take));
        }
        else {
            ({ items } = await this.HistoryService.get(this.getFilter(this.customerData), this.skipTickets, this.take));
        }
        const promises = items.map(async (item) => {
            const date = moment(item.storageDate).format('L');
            let operator = this.operators.find(o => o.identity === item.agentIdentity);
            if (!operator && item.agentIdentity) {
                try {
                    operator = await this.TeamService.getAccount(item.agentIdentity);
                    this.operators = [operator, ...this.operators];
                }
                catch (ex) {
                    operator = {
                        fullName: item.agentIdentity.split('@')[0],
                    };
                }
            }
            item.team = await this.updateIfTeamNameIsDirectTransfer(item.team);
            return { ...item, date, operator };
        });
        const moreTickets = (await Promise.all(promises));
        if (moreTickets.length == 0) {
            this.canLoadTickets = false;
        }
        this.tickets = this.tickets.concat(moreTickets.map((ticket) => {
            const avgResponseTime = this.toTimeString(Math.floor(ticket.averageAgentResponseTime));
            const convertedDateTime = this.convertDateTimeByOffset(ticket.storageDate, this.offset);
            const $day = moment(convertedDateTime).format('L');
            const $hour = moment(convertedDateTime).format('LT');
            const tagList = !ticket.tags
                ? []
                : ticket.tags.map(tag => {
                    return { text: tag };
                });
            const statusName = this.getStatusName(ticket);
            const statusDisplayDate = this.getStatusDate(ticket);
            return {
                ...ticket,
                $day,
                $hour,
                tagList,
                avgResponseTime,
                statusName,
                statusDisplayDate,
            };
        }));
    }
    toTimeString(val) {
        if (val) {
            const v = Math.floor(val);
            let d;
            let h;
            let m = Math.floor(v / 60);
            const s = v % 60;
            if (m > 60) {
                h = Math.floor(m / 60);
                m = m % 60;
            }
            if (h > 24) {
                d = Math.floor(h / 24);
                h = h % 24;
            }
            const days = this.getTimeString(d);
            const hrs = this.getTimeString(h) || '00';
            const mins = this.getTimeString(m) || '00';
            const secs = this.getTimeString(s) || '00';
            if (d) {
                return `${days}d ${hrs}:${mins}:${secs}`;
            }
            else {
                return `${hrs}:${mins}:${secs}`;
            }
        }
        else {
            return undefined;
        }
    }
    getTimeString(v) {
        if (v) {
            return v < 10 ? `0${v}` : `${v}`;
        }
        else {
            return undefined;
        }
    }
    getStatusName(ticket) {
        if (ticket.status === 'ClosedClientInactivity') {
            if (ticket.agentIdentity) {
                return 'DroppedInactivity';
            }
            return 'MissedInactivity';
        }
        if (ticket.status === 'ClosedClient') {
            if (ticket.agentIdentity) {
                return 'Dropped';
            }
            return 'Missed';
        }
        if (ticket.status === 'Open') {
            if (ticket.firstResponseDate) {
                return 'InAttendance';
            }
            return 'WaitingResponse';
        }
        return ticket.status;
    }
    getStatusDate(ticket) {
        if (ticket.status === 'Open' && ticket.firstResponseDate) {
            const firstResponseDateOffSet = this.convertDateTimeByOffset(ticket.firstResponseDate, this.offset);
            return moment(firstResponseDateOffSet).format('DD/MM/YYYY - HH:mm');
        }
        const statusDateOffSet = this.convertDateTimeByOffset(ticket.statusDate, this.offset);
        return moment(statusDateOffSet).format('L - LT');
    }
    async openUndoTicketLinkModal(ticket, $event) {
        $event.stopPropagation();
        const confirmLabel = await this.$translate('utils.forms.confirm');
        const cancelLabel = await this.$translate('utils.forms.cancel');
        const body = await this.$translate('modules.application.detail.attendance.history.ticketLink.confirmUndoMessage', { ticket: ticket.sequentialId, linkedTicket: this.linkedTicket.sequentialId });
        const title = await this.$translate('modules.application.detail.attendance.history.ticketLink.undoTitle');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: title,
            },
            body: body,
            buttons: {
                confirm: {
                    text: confirmLabel,
                },
                cancel: {
                    text: cancelLabel,
                },
            },
        }));
        const confirmation = await modal.close;
        if (!confirmation)
            return;
        try {
            this.trackUndoTicketLink();
            await this.TicketLinkService.delete(ticket.id);
            const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.undoSuccess');
            this.BlipToastService.show('success', { msg: message });
            this.getLinkedTicket(this.currentTicketId);
        }
        catch (_) {
            const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.error');
            this.BlipToastService.show('danger', { msg: message });
        }
    }
    async openTicketLinkModal(ticket, $event) {
        $event.stopPropagation();
        this.trackTicketLinkModalOpen();
        const modal = await this.ModalService.showModal({
            template: TicketLinkModalView,
            controller: TicketLinkModalController,
            controllerAs: '$ctrl',
            inputs: {
                originatorTicket: ticket,
                onRefresh: () => this.getLinkedTicket(this.currentTicketId),
            },
        });
        return await modal.close;
    }
    goToLinkedTicket() {
        const url = this.$state.href('auth.application.detail.attendance.history.detail', {
            id: this.UsersService.getDecodedUserIdentity(this.linkedTicket.customerIdentity),
            ticketId: this.linkedTicket.id,
        });
        window.open(url, '_blank');
    }
    async updateIfTeamNameIsDirectTransfer(team) {
        return team === AttendanceConstants.DIRECT_TRANSFER_TEAM
            ? await this.$translate('directTransfer')
            : team;
    }
    editingChanges() {
        const { test, ...rest } = this.editedCustomerData;
        return Object.keys(rest).filter(key => {
            return this.editedCustomerData[key] != this.customerData[key];
        });
    }
    // Segment
    trackUserOpened() {
        this.UsersSegmentService.trackUserOpened();
    }
    trackUserRefreshed() {
        this.UsersSegmentService.tracUserRefreshed();
    }
    trackUserInfoEdited(type) {
        this.UsersSegmentService.trackUserInfoEdited({
            Type: type,
        });
    }
    trackUserTestToggle(isTester, wasTester) {
        if (isTester !== wasTester) {
            this.UsersSegmentService.trackUserTestToggle();
        }
    }
    trackUserTicketHistoryCopied() {
        this.UsersSegmentService.trackUserTicketHistoryCopied({
            source: APP_DESCRIPTION,
        });
    }
    trackTicketLinkModalOpen() {
        this.UsersSegmentService.trackTicketLinkModalOpen();
    }
    trackTicketHistoryThreadViewed() {
        this.UsersSegmentService.trackTicketHistoryThreadViewed();
    }
    trackTicketHistoryDetailsExpanded() {
        this.UsersSegmentService.trackTicketHistoryDetailsExpanded();
    }
    trackUndoTicketLink() {
        this.UsersSegmentService.trackUndoTicketLink({
            ticketId: this.currentTicketId,
            linkedTicketId: this.linkedTicket.id,
        });
    }
}
UserDetailController.$inject = ['application', 'TeamService', 'HistoryService', 'LoadingService', 'UsersSegmentService', 'TenantService', '$timeout', '$stateParams', '$translate', 'ngToast', 'UsersService', '$scope', 'BlipToastService', 'MessagingHubService', '$state', 'ApplicationService2', 'AuthenticationService', 'CallsService', 'TranscriptionMfeService', 'DeskConfigurationService', 'MESSAGINGHUBDOMAIN', 'ModalService', 'TicketLinkService'];
